import events from 'events.js';
import ko from 'knockout';
import SearchManager, {Filter} from 'search/search.js';

const FILTER_TYPES = {
    'total': {
        title: 'All Results',
        icon: 'fa-search',
    },
    'factsheet_categories': {
        title: 'Condition Pages',
        icon: 'fa-stethoscope',
        colour: 'light-purple',
    },
    'drugs': {
        title: 'Product Pages',
        icon: 'fa-drug',
        colour: 'light-red',
    },
};

const DESKTOP_TYPE_LIMIT = 10;
const MOBILE_TYPE_LIMIT = 5;

class FactsheetSearchManager extends SearchManager {
    constructor(typeLimit) {
        super(typeLimit);
        this.filterTypes = FILTER_TYPES;
        this.baseUrl = '/factsheets/search/';
        this.types = ['factsheet_categories', 'drugs'];
        this.sortOrder = this.types;

        // Set default filter
        const filterType = this.filterTypes.total;
        this.currentFilter(
            new Filter(filterType.title, 'total', filterType.icon, this),
        );
    }
}

(async function() {
    await events.ready();
    const mgr = new FactsheetSearchManager(DESKTOP_TYPE_LIMIT);
    const search = document.getElementsByClassName('js-query')[0];

    function onFocus() {
        const offset =
            search.getBoundingClientRect().top +
            (document.body.scrollTop || document.documentElement.scrollTop);
        document.body.scrollTop = document.documentElement.scrollTop = offset;
    }

    if (matchMedia) {
        const mq = window.matchMedia('(min-width: 768px)');
        mq.addListener(widthChange);
        widthChange(mq);
    }

    function widthChange(mq) {
        if (mq.matches) {
            mgr.typeLimit(DESKTOP_TYPE_LIMIT);
            events.unlisten(search, 'focus', onFocus);
        } else {
            mgr.typeLimit(MOBILE_TYPE_LIMIT);
            events.listen(search, 'focus', onFocus);
        }
    }

    // Ensure if user already typed text binding won't erase it
    let existing = null;
    for (const elem of Array.from(
        document.getElementsByClassName('js-query'),
    )) {
        if (elem.value) {
            existing = elem.value;
            break;
        }
    }

    for (const elem of Array.from(
        document.getElementsByClassName('factsheet-autocomplete'),
    )) {
        ko.applyBindings(mgr, elem);
        mgr.elems.push(elem);
    }

    if (mgr.isSearchResults()) {
        ko.applyBindings(mgr, document.getElementById('search-area'));
        mgr.elems.push(document.getElementById('search-area'));
        ko.applyBindings(mgr, document.getElementById('search-title'));
        mgr.elems.push(document.getElementById('search-title'));
    }

    if (existing) {
        mgr.query(existing);
    }
})();
